<template>
  <div>
    <v-list three-line subheader>
      <v-subheader>奖励金记录</v-subheader>
      <p class="pa-4 text-xs-center" v-if="!bountyHistories.length">暂无奖励金变动记录</p>
      <v-list-tile v-for="bh in bountyHistories" :key="bh.id" v-else>
        <v-list-tile-content>
          <v-list-tile-title>{{getActionTitle(bh.action)}}</v-list-tile-title>
          <v-list-tile-sub-title>{{ bh.created_time }}</v-list-tile-sub-title>
          <v-list-tile-sub-title>{{ bh.remark }}</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-list-tile-title></v-list-tile-title>
          <v-list-tile-title v-text="bh.bounty" class="text-xs-right"></v-list-tile-title>
          <v-list-tile-title class="text-xs-right">来自：{{bh.user_name}}</v-list-tile-title>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider></v-divider>
    </v-list>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import userApi from '@/api/user'

export default {
  data() {
    return {
      bountyHistories: [],
    }
  },
  mounted() {
    this.getHistories()

  },
  methods: {
    ...mapActions([
      'HideLoading',
      'HideSmLoading',
      'ShowSmLoading'
    ]),
    getHistories() {
      userApi.getBountyHistory().then(res => {
        this.bountyHistories = res
        this.HideLoading()
      })
    },
    getActionTitle(action) {
      const actions = {
        unknown: '未知行为',
        buy_point: '购买积分奖励',
        buy_product: '解锁商品奖励',
        unlock_product: '解锁产品花费',
        unlock_cycle: '解锁周期奖励',
        system: '解锁周期奖励',
      }
      return actions[action]
    }
  }
}
</script>

<style lang="scss">
</style>
